export default {
  payWelfareText: 'Yükleme Avantajları',
  blackFridayDiscount: 'Kara Cuma Süreli İndirim',
  shareGift: 'Hediye Paylaş',
  vipWeeklyWelfare: 'Haftalık VIP İndirimi',
  exchangeCoupon: 'Kupon',
  firstPayOff: "1. Alışverişte %15'e Varan İNDİRİM",
  blackFridayEvent: 'Kara Cuma Etkinliği',
  limitedTimeOff: 'Sınırlı Süreli %10 İNDİRİM',
  claimCoupon: 'Şimdi Talep Et',
  blackFridayTimedCoupon: 'Kara Cuma Süreli Kupon',
  timeLeft: 'Kalan süre:',
  claimTimeCoupon: 'Şimdi %10 İNDİRİM Kuponu Talep Et!',
  points: 'Puanlar: ${point}',
  costPointTip: 'Puanlarınızı kuponlarla değiştirin',
  maxPointTip: 'Her hesap 500 puana kadar kullanabilir.',
  discountOff: '%10 İNDİRİM',
  highestDiscount: '$${discount}’a varan İNDİRİM',
  needPoint: '${point} puan gerekir',
  changeCurrency: 'Para Birimini Değiştir',
  claim: 'Talep Et',
  claimSucc: 'Talep edildi',
  claimFail: 'Başarısız',
  pointNotEnough: 'Yetersiz puan',
  afterClaimPoint: 'Kalan puan: ${point}',
  footTips1: 'Her sipariş için sadece 1 kupon kullanılabilir.',
  footTips2: 'Kupon, oyun içi para birimi/jeton satın almak için kullanılamaz.',
  footTips3: 'Bu etkinliğin nihai yorum hakkı bizde saklıdır',
  ruleTitleText: 'Etkinlik Kuralları',
  ruleTime: 'Etkinlik Süresi: 24 Kasım 2023 00.00 - 26 Kasım 2023 23.59 (UTC)',
  bfRuleText1:
    '1. Etkinlik sırasında resmi yükleme sayfasına ilk kez giriş yaptığınızda hesabınıza 400 puan yüklenecektir. Kuponlar için 500 puana kadar değişim yapabilirsiniz.',
  bfRuleText2:
    '2. Etkinlik sırasında Kara Cuma puanlarınızı kuponlarla değiştirebilirsiniz.',
  bfRuleText3:
    '3. Her sipariş için yalnızca 1 kupon kullanabilirsiniz. Kuponlar oyun içi para birimi/jeton satın almak için kullanılamaz.',
  bfRuleText4:
    '4. İşlemler için yalnızca aşağıdaki para birimlerini kabul ediyoruz:',
  ableCoinsType: '/',
  bfRuleText5:
    '5. Bir işlem yapıldıktan sonra para birimini değiştiremezsiniz. Değiştirilen puanlar iade edilemez.',
  bfRuleText6: '6. Kara Cuma kuponları yalnızca 7 gün boyunca geçerli olacaktır.',
  bfRuleText7: '7. Bu etkinliğin nihai yorum hakkı bizde saklıdır.',
  thanksTip:
    'Katılımınız için teşekkür ederiz. Daha fazla etkinlik bilgisi için lütfen resmi topluluğumuza katılın.',
  exchangePoints: 'Değiştir',
  exchangeCode: 'Değişim kodunu girin.',
  enterExchangeCode: 'Lütfen değişim kodunu girin.',
  exchangeText: 'Değiştir',
  confirmGet: 'Onayla',
  couponUsedWay:
    'Kupon yalnızca belirli para birimleriyle kullanılabilir, lütfen para biriminizi onaylayın.',
  confirmText: 'Onayla',
  exchangeSucc: 'Değiştirildi',
  aboutCoins: 'Oyun İçi Para Birimi/Jeton Hakkında',
  aboutCoinsText:
    'Oyun içi para birimini/jetonunu, oyun içi para biriminin/jetonunun kendisi hariç tüm paketler ve ayrıcalıklar için takas edebilirsiniz.',
  known: 'TAMAM',
  codeText: 'Kod',
  codeInvalid: 'Kod geçersiz!',
  hasExchanged: 'Daha fazla kod talep edemezsiniz.',
  hideText: 'Gizle',
  //黑五的报错码
  'bf-20001': 'Giriş yapılmadı',
  'bf-20002': 'Parametre hatası. Lütfen etkinliğe yeniden girmeyi dene.',
  'bf-20003': 'Yetersiz puan',
  'bf-20004':
    'Başarısız! Lütfen daha sonra tekrar dene veya Müşteri Desteği ile iletişime geç.',
  'bf-20005': 'Talep edildi',
  'bf-20015': 'Etkinlik şu anda mevcut değil.',
  'bf-20016': 'Etkinlik sona erdi.',
  bfShareText: 'Şimdi %10 İNDİRİM Kuponu Talep Et!',
  rightsCenterBtn: 'Ayrıcalıklı Üye Merkezi',
  payBtn: 'TOP UP',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Olağanüstü Görkemli (Süresiz)',
  '-': '-'
};
